import { cn } from '@cobliteam/ui/utils';

type AIBetaFlagVariant = 'default' | 'light';

interface AIBetaFlagProps {
  variant?: AIBetaFlagVariant;
  className?: string;
}

const AIBetaFlag = ({ variant = 'default', className }: AIBetaFlagProps) => (
  <span
    className={cn('rounded px-1.5 py-0.5 font-semibold text-[10px] uppercase leading-none', variant === 'light' ? 'bg-white/20 text-white' : 'bg-[#FFA931] text-black', className)}
  >
    Beta
  </span>
);

export default AIBetaFlag;
